export const EVENT_SET = 'pay-check.EVENT_SET'
export const PHONE_SET = 'pay-check.PHONE_SET'
export const TOTAL_PRICE_SET = 'pay-check.TOTAL_PRICE_SET'
export const ITEMS_SET = 'pay-check.ITEMS_SET'
export const LOADING_SET = 'pay-check.LOADING_SET'
export const SCREEN_SET = 'pay-check.SCREEN_SET'
export const ERROR_SET = 'pay-check.ERROR_SET'
export const CHARGE_ID_SET = 'pay-check.CHARGE_ID_SET'

export const ORDER_ID_SET = 'pay-check.ORDER_ID_SET'
export const CUSTOMER_ID_SET = 'pay-check.CUSTOMER_ID_SET'
export const EVENT_ID_SET = 'pay-check.EVENT_ID_SET'
export const FEE_SET = 'pay-check.FEE_SET'
